<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      generateSessionId: 'user/generateSessionId'
    })
  },
  mounted () {
    this.generateSessionId()
  }
}
</script>

<style>
  .full-height-overflow-hidden {
    height: 100%;
    overflow: hidden;
  }
</style>
